module.exports = __webpack_public_path__ + "static/media/pizzas.8c0c8b64.jpg";